import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { Box, ButtonBase, Typography } from '@mui/material';
import { memo } from 'react';

import { containerSx, seeAllSx, subtitleSx, titleSx } from './styles';

type TSectionHeaderProps = {
  title: string;
  subtitle?: string;
  onSeeAll?: () => void;
};

export const SectionHeader = memo(({ title, subtitle, onSeeAll }: TSectionHeaderProps) => {
  return (
    <Box>
      <Box sx={containerSx}>
        <Typography sx={titleSx}>{title}</Typography>
        {onSeeAll && (
          <ButtonBase sx={seeAllSx} onClick={onSeeAll} disableRipple>
            See all
            <ChevronRightIcon sx={{ fontSize: 18 }} />
          </ButtonBase>
        )}
      </Box>
      {subtitle && <Typography sx={subtitleSx}>{subtitle}</Typography>}
    </Box>
  );
});
